import React from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import TableWithSections from '../tables/TableWithSections'
import { percentage } from '../utils/formatters'
import pluckResultsByType from '../utils/pluckResultsByType'

interface Props {
  configuration: ModelAPI.ConfigurationResponse
  data: ModelAPI.TeamResultsResponse['revenue']
}

const fieldFormatterMap: { [field: string]: string } = {
  'HOME_LOANS.interest': 'Home Loans (Interest)',
  'HOME_LOANS.obi': 'Home Loans (OBI)',
  'BUSINESS_LOANS.interest': 'Business Lending (Interest)',
  'BUSINESS_LOANS.unethicalInterest': 'Business Lending (Unethical Interest)',
  'BUSINESS_LOANS.obi': 'Business Lending (OBI)',
  'DEPOSITS.interest': 'Deposits (Interest)',
  'DEPOSITS.obi': 'Deposits (OBI)',
  'CREDIT_CARDS.interest': 'Credit Cards (Interest)',
  'CREDIT_CARDS.cardFees': 'Credit Cards (Card Fees)',
  'CREDIT_CARDS.interchange': 'Credit Cards (Interchange)',
  'CREDIT_CARDS.rewardCosts': 'Credit Cards (Reward Costs)'
}

const ModelTeamResultsRevenue: React.FC<Props> = ({ data }) => {


  return (<>
    <VerticalGroup className='mt-2' spaceBetweenElements={2} wide>
      <TableWithSections
        header='Revenue Calculations'
        data={[{
          name: 'Extra Revenue',
          fields: [
            'HOME_LOANS',
            'BUSINESS_LOANS',
            'DEPOSITS',
            'CREDIT_CARDS'
          ],
          values: pluckResultsByType(data, 'extraRevenue'),
        }, {
          name: 'Credit Cards Interest Rate',
          fields: [
            'effectiveCreditCardInterestRate'
          ],
          values: pluckResultsByType(data, 'creditCardsInterestRate'),
          formatter: (val: number) => percentage(val, 2)
        }, {
          name: 'Primary Revenue / Expense',
          fields: [
            'HOME_LOANS.interest',
            'HOME_LOANS.obi',
            'BUSINESS_LOANS.interest',
            'BUSINESS_LOANS.unethicalInterest',
            'BUSINESS_LOANS.obi',
            'DEPOSITS.interest',
            'DEPOSITS.obi',
            'CREDIT_CARDS.interest',
            'CREDIT_CARDS.cardFees',
            'CREDIT_CARDS.interchange',
            'CREDIT_CARDS.rewardCosts'
          ],
          values: pluckResultsByType(data, 'primaryRevenueExpense'),
        }]}
        fieldFormatter={(field: string) => fieldFormatterMap[field] ?? null}
      />
    </VerticalGroup>
  </>)
}

export default ModelTeamResultsRevenue